import {Paper} from "@mui/material";
import styled from "styled-components";

export const PaperStyle = styled(Paper)`
  /* padding: 20px 20px 50px 20px; */

  && {
    background-color: transparent;
    box-shadow: none;
  }
`;

